// ─── FIREBASE CONFIG ─────────────────────────────────────────────────────────
// Substitua os valores abaixo pelos do seu projeto Firebase.
// Acesse: https://console.firebase.google.com → Seu projeto → Configurações → Seus apps

import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey:            process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyAhtbHv-vChVaJYWwIbzv04LSG3nsvyTF8",
  authDomain:        process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "portalvieiramelul.firebaseapp.com",
  projectId:         process.env.REACT_APP_FIREBASE_PROJECT_ID || "portalvieiramelul",
  storageBucket:     process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "portalvieiramelul.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "988628220285",
  appId:             process.env.REACT_APP_FIREBASE_APP_ID || "1:988628220285:web:c7d32641d3d548fcd3b414",
};

const app = initializeApp(firebaseConfig);
export const db      = getFirestore(app);
export const auth    = getAuth(app);
export const storage = getStorage(app);
